import { motion, AnimatePresence } from "framer-motion";
import { usePlaybackHealthStore } from "@/features/tutor/store/usePlaybackHealthStore";

interface PlaybackToastProps {
  onTap?: () => void;
}

const PlaybackToast = ({ onTap }: PlaybackToastProps) => {
  const { audioSuspended } = usePlaybackHealthStore();

  return (
    <AnimatePresence>
      {audioSuspended && (
        <motion.div
          key="audio-suspended"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="flex justify-center pointer-events-none w-full"
        >
          <div
            className={`flex items-center gap-3 px-5 py-[15px] bg-[#FFF0D1] rounded-[10px] pointer-events-auto ${onTap ? "cursor-pointer" : ""}`}
            onClick={onTap}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 5L6 9H2v6h4l5 4V5z"
                stroke="#FF8400"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="23"
                y1="9"
                x2="17"
                y2="15"
                stroke="#FF8400"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <line
                x1="17"
                y1="9"
                x2="23"
                y2="15"
                stroke="#FF8400"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            <span className="font-nunito text-base font-semibold text-black">
              Tap to enable tutor audio
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PlaybackToast;
